export default __webpack_public_path__ + "static/media/ksivalue_small@2x.9ac3f63b.jpg";